<div class="desktop-update-splash">
  <img src="/assets/images/illustrations/error.svg" alt="App out of date" />
  <p>
    This version of the app is no longer supported.<br />
    Please download and install the newest version or contact your administrator to update the app.
    <br />
    <br />
    <a ftrButton [href]="downloadUrl" [flexLayout]="true" color="primary" target="_blank">
      <ftr-icon-legacy icon="Download" size="Large" gapRight="Small" />
      Download App
    </a>
  </p>
</div>
